// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hr-7";
export var emphasizeQuantity = "_hr-3";
export var flatBottomCorners = "_hr-5";
export var productImage = "_hr-0";
export var quantityContainer = "_hr-2";
export var quantityHeader = "_hr-6";
export var tooltip = "_hr-1";
export var wrapAndEllipsesOverflow = "_hr-4";